import React, {useState} from 'react'
import TextField from '@material-ui/core/TextField';
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import { getAnalyzeDialogType, getConfirmationIcon } from "../utils/utils"
import InputMask from "react-input-mask";
import axios from 'axios'
import { CircularProgress } from '@material-ui/core';

const theme = createMuiTheme({
    palette:{
        primary: {
            main:"#0b1f82"
        },
        secondary: {
            main: "#FF0000"
        },
    }
  });

function ShopeeWithCNHInputContent (props){
    const [error, setError] = useState(true)
    const [cnhError, setCnhError] = useState(true)
    const [value, setValue] = useState({
            document_number: "",
            cnh: "",
    })
    const [pendingState, setPendingState] = useState(false)
    const [status, setStatus] = useState(null)

    let inputObject = getAnalyzeDialogType(props.local_storage_object_preffix)

    const handleChangeDocumentNumber = (event) => {
        setValue({...value, document_number: (event.target)?.value})
        if ((event.target?.value).length !== inputObject.validation_size) { 
            setError(true)
        }
        else {
            setError(false)
        }
      }

    const handleChangeCnh = (event) => {
        const text = (event.target)?.value;
        if (text == null) return
        const sanitizedText = text.replace(/[^0-9]/g, '').trim();
        if (sanitizedText.length <= 11) {
            setCnhError(true)
            setValue((prev) => ({...prev, cnh: sanitizedText}))
        } else {
            setCnhError(false)
        }
    }

    const handleBackClick = () => {
        props.setSelectCompany({
            status:true,
        })
    }

    const handleReturn = () => {
        props.onClose()
        props.setPageParams({page: 1, filters: JSON.parse(sessionStorage.getItem(props.local_storage_object_preffix + 'PageParams')).filters})
    }

    const onSubmit = () => {
        if (error || cnhError) return
        let requestHeaders = { headers:{'company_key': props.company_key}}
        const payload = {
            document_number: value.document_number,
            documents: {
                cnh: {
                    register_number: value.cnh,
                }
            },
        }
        setPendingState(true)
        axios.post('/dash/onboarding/' + inputObject.post_endpoint, payload, requestHeaders).then(response => {
            setPendingState(false)
            if (response.data.analysis_status === "pending" || response.data.analysis_status === "in_queue"){
                setStatus({success: true, message: "Em Processamento."})
            }
            else{
                setStatus({success: true, message: "Requisição processada com sucesso"})
            }
        }).catch(error => {
            setPendingState(false)
            let errorMessage = "Não foi possível processar sua requisição"
            if ((error.response || {}).status === 400) {
                errorMessage = "O documento inserido não é um número de documento válido."
            }
            if ((error.response || {}).status === 401) {
                if (((error.response || {}).data || {}).message === "maximum_demo_analysis_limit_reached") {
                    errorMessage = "O limite máximo de requisições teste na sua conta demonstração foi excedido."
                }
                else if (((error.response || {}).data || {}).message === "account_manual_requests_unauthorized") {
                    errorMessage = "Sua conta não permite análises manuais."
                }
            }
            if ((error.response || {}).status === 402) {
                errorMessage = "Requisição não autorizada pela carteira, verifique seus dados de pagamento e cadastro da cartão na página de pagamentos."
            }
            setStatus({success: false, message: errorMessage})
        });
    }
    
    if (pendingState) {
        return(
            <div style={{display:"flex", flexGrow:"1"}}>
                <CircularProgress style={{margin:"auto"}}/>
            </div>
        )
    }
    if (status != null) {
        return(
            <div style={{ display:"flex", flexDirection:"column", flexGrow:"1"}}>
                <div style={{margin:"auto"}}>
                    {getConfirmationIcon(status.success)}
                </div>
                <div style={{margin:"auto", textAlign: 'center'}}>
                    {status.message}
                </div>
                <div
                    onClick={handleReturn} 
                    className={["button","standard", "normalText", "normalMediumSize"].join(" ")} 
                    style={{margin:"20px auto 20px auto", width:"auto"}}
                >
                    VOLTAR À PÁGINA INICIAL
                </div>
            </div>
        )
    }

    return (
        <div style={{ display:"flex", flexDirection:"column", flexGrow:"1"}}>
            <div style={{margin:"10px auto"}}>
                <ThemeProvider theme={theme}>
                    <div style={{display: "flex", flexDirection: "column", gap: "8px", width: '100%', marginBottom: '16px', justifyContent: 'center', alignItems: 'center'}}>
                        <InputMask 
                            mask={inputObject.mask_type}
                            maskPlaceholder=""
                            value={value.document_number}
                            name="document_number"
                            onChange={handleChangeDocumentNumber}
                        >
                            <TextField 
                                focused 
                                color={(error && (value?.document_number == null || value?.document_number?.length > 0)) ? "secondary": "primary"} 
                                label="Digite o CPF"
                                onKeyPress= {(e) => {if (e.key === 'Enter') {onSubmit()}}} 
                            />
                        </InputMask>
                        <TextField 
                            focused 
                            label="Digite a CNH"
                            value={value.cnh}
                            color={(cnhError && (value?.cnh == null || value?.cnh?.length > 0)) ? "secondary": "primary"}
                            onChange={handleChangeCnh}
                            onKeyPress= {(e) => {if (e.key === 'Enter') {onSubmit()}}} 
                        />
                    </div>
                </ThemeProvider>
            </div>
            <div style={{display:"flex", flexDirection:"row", justifyContent: "center", margin:"auto 0px 20px 0px"}}>
                <div
                    className={error || cnhError ? ["button","standard", "disabled", "normalText", "normalMediumSize"].join(" ") : ["button","standard", "normalText", "normalMediumSize"].join(" ")} 
                    onClick={onSubmit} 
                    style={{width:"40%"}}
                >
                    Finalizar
                </div>
                {props.business_group_key == null ? null:
                <div
                    className={["button","cancel"].join(" ")} 
                    onClick={handleBackClick} 
                    style={{width:"40%"}}
                >
                    Retornar
                </div>
                }
            </div>
        </div>
    )

}

export default ShopeeWithCNHInputContent